import Vue from "vue";
import axios from "axios";
import qs from "qs";

const initialState = {
    lists: [],
	selectableLists: [],
	listHeaders: {},
    currentList: {list_name:'Select List'},
	settingsList: {},
    listMembers: [],
	listMembersTotal: 0,
	listRecentMembers: [],
    nonListMembers: [],
	list_templates: [],
	templates:{},
	templates_json: {},
	templates_html: {},
	listCreating: false,
};

export const state = { ...initialState };

export const actions = {



    async listCreate (context,name){

        var obj = {
            name: name
        }

        axios.post("/api/1/lists",qs.stringify(obj)).then(function(response){
            if(response.data.success){
                return actions.listLoad(context);
            }
        });
    },

    listRename(context,list){

        axios.post("/api/1/lists/"+list.tid,qs.stringify(list)).then(function(response){
        });

    },

    async listDelete(context,list){
        return axios.delete("/api/1/lists/"+list.tid);
    },



    async listLoad (context,query) {

		var params = {};

		if(query){

			params.query = query;

		}


        return axios.get("/api/1/lists", {params:params}).then(function(response){
            
            context.commit('listSet',response.data.result);

        });

    },

	async loadTeamTemplates(context,list_id){

		return axios.get("/api/1/teamTemplates",{params:{list_id:list_id}}).then(function(response){
            context.commit('setTemplates',response.data.result);

        });

	},

	async loadListTemplates(context){

		return axios.get("/api/1/templates").then(function(response){
            context.commit('setListTemplates',response.data.result);

        });

	},
	updateListTemplates(context,templates){
		context.commit('replaceTemplates',templates);
	},
	updateTemplate(context,data){
		context.commit("setFieldTemplate",data);
	},
	updateTemplateJson(context,data){
		context.commit("setFieldTemplateJson",data);
	},
	updateTemplateHtml(context,data){
		context.commit("setFieldTemplateHtml",data);
	},

	resetTemplatesJson(context){
		context.commit("clearTemplatesJson");
	},

	resetTemplatesHtml(context){
		context.commit("clearTemplatesHtml");
	},

	updateSettingsListField(context,data){
		context.commit("setSettingsListField", data);
	},

    listCurrentLoad (context,user_id) {
        axios.get("/api/1/users/" + user_id + "/activelist").then(function(response){

            if(response.data.success){
                context.commit('listSetFromID',response.data.result);
            }
            
        });
    },

	listCurrentReset(context){
		context.commit('listSelect',{list_name:'Select List'});
	},

    listSelect (context, list) {
        context.commit('listSelect',list);
    },

    listSelectFromID(context, id){
        context.commit('listSetFromID',id);
    },

    listSetActive(context, obj){

        var data= {
            tact:obj.tact
        }

        axios.put("/api/1/dataupdate/lists/"+obj.tid,qs.stringify(data)).then(function(response){

            if(response.data.success){

                actions.listLoad(context);

            }

        });

    },

    async singleListLoad(context, list_id){
        return axios.get("/api/1/lists/"+list_id).then(function(response){
            if(response.data.success){
				if(response.data.result.length>0){
					context.commit('listSelect',response.data.result[0]);
				}
                
            }
        });

    },

	async reloadListAndAdmissions(context, list_id){
		//do admissions and list so that when we change lists all the data is changed at once
		//this prevents janky list changing

		var list = null;
		var admissions = null;

		var listPromise = axios.get("/api/1/lists/"+list_id).then(function(response){
            if(response.data.success){
				if(response.data.result.length>0){
					list = response.data.result[0];
				}
                
            }
        });

		var admissionsPromise = axios.get("/api/1/admissions", {
			params: context.rootState.admissions.admissionsParams
		}).then(function(response){
			admissions = response.data.result.admissions;
		});

		return Promise.all([listPromise,admissionsPromise]).then(function(){
			if(list&&admissions){
				context.commit('listSelect',list);
				context.commit("setAdmissions",admissions);
			}
		})

	},


    async listLoadMembers (context,id) {

        return axios.get("/api/1/lists/" + id + "/members").then(function(response){
            if(response.data.success){
                context.commit('listSetMembers',response.data.result);
            }

        });


    },

	async listLoadRecentMembers (context,id) {

        return axios.get("/api/1/lists/" + id + "/recent/members").then(function(response){
            if(response.data.success){
                context.commit('listSetRecentMembers',response.data.result.members);
				context.commit('listSetMembersTotal',response.data.result.total);
            }

        });


    },

    async listAddMembers(context,data) {

        var members = data.members;
        var list = data.list;

        var promises = [];
        for(var i=0; i<members.length; i++){
            promises.push(
                axios.put("/api/1/lists/" + list + "/members/" + members[i].uid)
            );
        }

        return Promise.all(promises).then(function(){
            actions.listLoadMembers(context,list);
        })

        

    },

    updateListMemberPerm (context,obj) {

        var data = {};

        if(obj.value=="View only"){
            data.mprm = '';
            data.mact = '';
        }else if(obj.value=="Edit lists"){
            data.mprm = '';
            data.mact = '1';
        }
        axios.put("/api/1/dataupdate/members/"+obj.mid,qs.stringify(data));


    },

    async removeListMember (context,obj){

        return axios.delete("/api/1/lists/"+obj.mtid+"/members/"+obj.muid).then(function(response){
  
        })

    },

    listLoadNonMembers (context,tid){

        var obj = {
            params:{
                tid: tid
            }
        }

        axios.get("/api/1/nonmembers",obj).then(function(response){
            context.commit('listSetNonMembers',response.data.result);
        });

    },

	async listUpdateEvent(context,event){
		var list_id = event.list_id;

		if(context.state.currentList.list_id==list_id){
			actions.singleListLoad(context,list_id);
			actions.loadTeamTemplates(context,list_id);
		}

	},

	async listDeleteEvent(context,event){
		var list_id = event.list_id;

		var current_location = window.location.hash


		if(context.state.currentList.list_id==list_id&&current_location.match("#/list/[0-9]+")){
			alert("This list has been deleted.");
			actions.listCurrentReset(context);
			actions.listLoad(context);

			var current_app = context.rootState.user.current_app;
			var location = "/#/list";
			
			if(current_app=="board"){
				var location = "/#/board";
			}else if(current_app=="card"){
				var location = "/#/list-open";
			}

			window.location = location;
		}
	},

	async sosListsUpdateEvent(context){
		actions.listLoad(context);
	},

	async userListsUpdate(context,event){
		var user_id = event.user_id;
		var list_id = event.list_id;

		if(context.rootState.user.user.uid==user_id){

			if(context.rootState.list.currentList.list_id == list_id){
				actions.listCurrentReset(context)
			}

		}
		

	},

	creatingList(context){
		context.commit("setListCreating",true);
	},

	createdList(context){
		context.commit("setListCreating",false);
	},


}

export const mutations = {

    listSet (state,data) {
        state.lists = data;

		state.selectableLists = [];

		for(var i=0; i<data.length; i++){


			if(data[i].mid){
				state.selectableLists.push(data[i]);
			}

			data[i].display_order = JSON.parse(data[i].display_order);

			var team_id = data[i].list_id.toString();
			

			var in_use_headers = [];

			for(var j=0; j<9; j++){

				var display_order_column = data[i].display_order[j];
				
				if(data[i]["column_" + display_order_column + "_toggle"]==1){
					in_use_headers.push(display_order_column);
				}
	
			}

			var result = {
				headers: in_use_headers,
				list: data[i]
			}

			state.listHeaders[team_id] = result;


		}

		var unlink_team_id = 100000000;

		state.listHeaders[unlink_team_id] = {headers:[1,2,3,4,5,6,7], list:{}}


    },

    listSetFromID(state,id){

        for(var i=0; i<state.lists.length;i++){
            if(state.lists[i].tid == id){
                state.currentList = state.lists[i];
            }
        }

    },

    listSelect(state,data) {
        state.currentList = data;
		state.settingsList = JSON.parse(JSON.stringify(data));
		if(state.currentList.list_id){
			state.currentList.display_order = JSON.parse(state.currentList.display_order);
			state.settingsList.display_order = JSON.parse(state.settingsList.display_order);
		}
    },

	setSettingsListField(state,data){
		state.settingsList[data.field] = data.value;
	},

    listSetMembers(state,data){
        state.listMembers = data;
    },

	listSetRecentMembers(state,data){
		state.listRecentMembers = data;
	},

	listSetMembersTotal(state,data){
        state.listMembersTotal = data;
    },

    listSetNonMembers(state,data){
        state.nonListMembers = data;
    },

	setListTemplates(state,data){
		state.list_templates = data
	},

	setTemplates(state,data){

		var templates_obj = {};

		for(var i=0;i<data.length;i++){
			templates_obj[data[i].field] = data[i].template
		}

		state.templates=templates_obj;

	},

	replaceTemplates(state,data){

		var templates_obj = {};

		for(var key in data){
			templates_obj[key] = data[key]			
		}

		state.templates=templates_obj;
	},

	setFieldTemplate(state,data){
		Vue.set(state.templates, data.field, data.value)
	},

	setFieldTemplateJson(state,data){
		Vue.set(state.templates_json, data.field, data.value);
	},
	setFieldTemplateHtml(state,data){
		Vue.set(state.templates_html, data.field, data.value);
	},

	clearTemplatesJson(state){
		state.templates_json = {};
	},
	clearTemplatesHtml(state){
		state.templates_html = {};
	},

	setListCreating(state,value){
		state.listCreating = value;
	}
	

}

const getters = {
    lists(state){
        return state.lists;
    },
    currentList(state){
        return state.currentList;
    },
	settingsList(state){
		return state.settingsList;
	},
    listMembers(state){
        return state.listMembers;
    },
	listMembersTotal(state){
		return state.listMembersTotal;
	},
	listRecentMembers(state){
		return state.listRecentMembers;
	},
    nonListMembers(state){
        return state.nonListMembers;
    },
	list_templates(state){
		return state.list_templates;
	},
	templates(state){
		return state.templates;
	},
	templates_json(state){
		return state.templates_json;
	},
	templates_html(state){
		return state.templates_html;
	},

	inUseListColumns(state){

		var result = [];

		for(var i=0; i<9; i++){

			var display_order_column = state.currentList.display_order[i];

			if(state.currentList["column_" + display_order_column +"_toggle"]==1){
				result.push(display_order_column);
			}

		}

		return result;

	},

	visibleListColumns(state){

		var result = [];

		for(var i=0; i<9; i++){

			var display_order_column = state.currentList.display_order[i];

			if(state.currentList["column_" + display_order_column +"_toggle"]==1){
				result.push(display_order_column);
			}

		}

		return result;

	},

	settingsVisibleListColumns(state){

		var result = [];

		

		for(var i=0; i<9; i++){

			var display_order_column = state.settingsList.display_order[i];

			if(state.settingsList["column_" + display_order_column +"_toggle"]==1){
				result.push(display_order_column);
			}

		}

		return result;

	},

	listHeaders(state){
		return state.listHeaders;
	},

	selectableLists(state){
		var result = state.selectableLists;

		if(state.selectableLists.length==0){
			result.push({
				list_name: "Add SOS List",
				list_id: "open_modal"
			});
		}

		return result;
	},

	listCreating(state){
		return state.listCreating;
	},

	displayedSectionName(state){
		var result = state.currentList.section_name;

		if(result==""){
			result = "Section"
		}

		return result;
	},
	displayedOrderName(state){
		var result = state.currentList.order_name;

		if(result==""){
			result = "Order"
		}

		return result;
	}
};

export default {
    state,
    actions,
    mutations,
    getters
  };
  